<template>
    <html-container
      v-if="htmlHead"
      label="Pre-conditions"
      :htmlContent="htmlHead"
    ></html-container>
</template>
<script>
import HtmlContainer from './sub/HtmlContainer'

export default {
  name: 'QuestionPreConditions',
  components: {
    'html-container': HtmlContainer
  },
  props: {
    'html-head': {
      type: String,
      default: '',
      required: false
    }
  }
}
</script>
